import React from "react"
import TechInfo from "./TechInfo"
import TechImages from "./TechImages"
import { AosWrapper } from "../../molecules/AosWrapper"
import { Container, Wrapper } from "./styles"

const TechCompany: React.FC = () => {
  return (
    <Wrapper id={"about-rtw"}>
      <AosWrapper>
        <Container>
          <TechInfo />
          <TechImages />
        </Container>
      </AosWrapper>
    </Wrapper>
  )
}

export { TechCompany }
